// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgBoat = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path d="M16.672 16.729a3.644 3.644 0 0 0-.379-.335 4.321 4.321 0 0 0-1.224-.659c-1.028-.352-2.6-.447-4.66.894-2.44 1.588-4.493 1.559-5.965 1.054a5.827 5.827 0 0 1-1.651-.887 5.149 5.149 0 0 1-.558-.497l-.034-.038-.012-.013-.006-.006c.002-.003.036-.033.567-.492l.089-.077-.657.567a.75.75 0 0 1 1.134-.982v-.001l.012.014c.014.014.037.039.07.07.066.065.17.159.309.266.279.214.692.474 1.223.657 1.028.352 2.6.448 4.66-.893 2.44-1.588 4.493-1.559 5.966-1.054a5.825 5.825 0 0 1 1.65.887 5.126 5.126 0 0 1 .558.497l.035.038.011.012.004.005.002.002c-.002.003-.035.032-.5.434l.501-.432a.75.75 0 0 1-1.135.981h.001l-.011-.012ZM9.658 2.289A.75.75 0 0 1 11 2.75V9h6a.75.75 0 0 1 .67 1.085l-1.25 2.5a.75.75 0 0 1-1.341-.67l.707-1.415H4.184l1.15 2.429a.75.75 0 0 1-1.356.642l-1.656-3.5A.751.751 0 0 1 3 9.001h1.438l5.22-6.712ZM6.338 9H9.5V4.936L6.339 9Z" />
  </svg>
)

export default SvgBoat
